var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 2,
    viewBox: "0 0 11 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5312 0.09375C10.6406 0.09375 10.75 0.203125 10.75 0.3125V1.1875C10.75 1.32422 10.6406 1.40625 10.5312 1.40625H0.46875C0.332031 1.40625 0.25 1.32422 0.25 1.1875V0.3125C0.25 0.203125 0.332031 0.09375 0.46875 0.09375H10.5312Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.fc7951314f3d8b703c8267a5989d2459.svg";
export { ForwardRef as ReactComponent };